export const URL_VALIDATION_REGEX = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&/=]*)$/;

export const sameUrl = (firstUrl: string, secondUrl: string): boolean => {
  const url1 = new URL(firstUrl);
  const url2 = new URL(secondUrl);
  const url1Pathname = url1.pathname.replace(/\/+$/, '');
  const url2Pathname = url2.pathname.replace(/\/+$/, '');
  return url1.host === url2.host && url1Pathname === url2Pathname;
};
